import React, {useEffect, useState} from 'react';
import ReportUtils from "../../../../../../utils/report-utils.js";
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";

const DetentionsReasonContent = ({ data }) => {
    const detentions = data?.detention_nature ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = detentions.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    useEffect(() => {
        if (!detentions?.length) return;
        const values = [];

        detentions.map((element) => {
            values.push([
                element.nature,
                element.qty
            ]);
        })

        ReportUtils.createExportableTable(["Natureza", "Quantidade"], values, 'Detenções por natureza');
    }, [data]);

    return (
        <>
            <div className="mt-4 print:break-inside-avoid">
                <span className="chart-title mb-2">Detenções por natureza {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>
                <table id="detentions-by-reason-data" className="table report-table mt-2" sheet-name={'Detenções por natureza'}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[85%]">Natureza</th>
                            <th className="w-[15%]">Quantidade</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !detentions?.length ? (
                            <NoDataRow colSpan={2} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? detentions.slice(0, limit) : detentions).map((element, index) => (
                            <tr key={index}>
                                <td className="w-[85%]">{element.nature}</td>
                                <td className="w-[15%]">{element.qty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>

            <div className="chart-divisor print:hidden"/>
        </>
    );
};

export default DetentionsReasonContent;